import React, { ReactNode } from 'react'
import {
  ButtonProps,
  StyledThemedAnchor,
  StyledThemedButton,
  StyledThemedLink,
} from './styles'

interface Props {
  href?: string
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>
  type?: 'button' | 'submit' | 'reset' | undefined
  $styleType?: string
  text: string | ReactNode
  isExternal?: boolean
  isMail?: boolean
  w?: string
  p?: string
}

export const ThemedAnchor = ({
  href,
  children,
  disabled,
  isMail,
  $styleType,
  onClick,
  p,
  w,
}: {
  href?: string
  disabled?: boolean
  $styleType?: string
  children: ReactNode
  isMail?: boolean
  onClick?: () => void
  p?: string
  w?: string
}) => {
  return (
    <StyledThemedAnchor
      href={href}
      disabled={disabled}
      $styleType={$styleType}
      target={isMail ? '_self' : '_blank'}
      rel="noreferrer"
      onClick={onClick}
      p={p}
      w={w}
    >
      {children}
    </StyledThemedAnchor>
  )
}

export const ThemedLink = ({
  to,
  children,
  onClick,
  $styleType,
  w = 'auto',
}: {
  to: string
  onClick?: () => void
  $styleType?: string
  children: ReactNode
  w?: string
}) => {
  return (
    <StyledThemedLink to={to} $styleType={$styleType} w={w} onClick={onClick}>
      {children}
    </StyledThemedLink>
  )
}

export const ThemedButton = ({
  children,
  type,
  $styleType,
  disabled,
  onClick,
  w = 'auto',
  p,
  className,
  ...rest
}: {
  children: ReactNode
  type?: 'button' | 'submit' | 'reset' | undefined
  $styleType?: string
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>
  w?: string
  p?: string
  className?: string
} & ButtonProps) => {
  return (
    <StyledThemedButton
      disabled={disabled}
      onClick={!disabled ? onClick : () => { }}
      type={type}
      $styleType={$styleType}
      w={w}
      p={p}
      className={className}
      {...rest}
    >
      {children}
    </StyledThemedButton>
  )
}

const Button = ({
  href,
  disabled,
  onClick,
  type,
  $styleType,
  text,
  isExternal = false,
  isMail = false,
  w = 'auto',
  p,
}: Props) => {
  return href ? (
    isExternal ? (
      <ThemedAnchor
        href={href}
        disabled={disabled}
        $styleType={$styleType}
        isMail={isMail}
      >
        {text}
      </ThemedAnchor>
    ) : (
      <ThemedLink to={href} $styleType={$styleType}>
        {text}
      </ThemedLink>
    )
  ) : (
    <ThemedButton
      disabled={disabled}
      onClick={!disabled ? onClick : () => { }}
      type={type}
      $styleType={$styleType}
      w={w}
      p={p}
    >
      {text}
    </ThemedButton>
  )
}

export default Button
